export default __webpack_public_path__ + "static/twitterpreview-6c30f7e619759de4be2486e15cf60653.png";